import { render, staticRenderFns } from "./GaleriaFotosAdministracao.vue?vue&type=template&id=05465d20&scoped=true"
import script from "./GaleriaFotosAdministracao.vue?vue&type=script&lang=js"
export * from "./GaleriaFotosAdministracao.vue?vue&type=script&lang=js"
import style0 from "./GaleriaFotosAdministracao.vue?vue&type=style&index=0&id=05465d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05465d20",
  null
  
)

export default component.exports